import React from 'react';
import { Divider, Empty, List, Avatar, Checkbox, Spin, Tag, Card, Row, Col } from 'antd';
import { VideoCameraOutlined, CheckCircleFilled } from '@ant-design/icons';
import { YingshiCamera } from './types';

interface YingshiCameraListProps {
  yingshiCameras: YingshiCamera[];
  selectedCameras: YingshiCamera[];
  yingshiLoading: boolean;
  selectedYingshiDevice: boolean;
  editingExistingChannels: boolean;
  handleToggleCamera: (camera: YingshiCamera) => void;
}

const YingshiCameraList: React.FC<YingshiCameraListProps> = ({
  yingshiCameras,
  selectedCameras,
  yingshiLoading,
  selectedYingshiDevice,
  editingExistingChannels,
  handleToggleCamera,
}) => {
  return (
    <div className="yingshi-section">
      <Divider orientation="left" style={{ margin: '8px 0' }}>选择通道</Divider>
      <Spin spinning={yingshiLoading}>
        {selectedYingshiDevice || (editingExistingChannels && selectedCameras.length > 0) ? (
          <div>
            {selectedCameras.length > 0 && (
              <Card 
                size="small" 
                style={{ 
                  marginBottom: 8, 
                  backgroundColor: '#f6ffed', 
                  borderColor: '#b7eb8f',
                  padding: '4px 8px'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CheckCircleFilled style={{ color: '#52c41a', marginRight: 8 }} />
                  <span style={{ fontWeight: 500 }}>已选择 {selectedCameras.length} 个通道</span>
                </div>
                {selectedCameras.length > 0 && !selectedYingshiDevice && (
                  <div style={{ marginTop: 4, color: '#1890ff', fontSize: '12px' }}>
                    这些是设备已配置的通道。选择设备后可查看和修改通道列表。
                  </div>
                )}
              </Card>
            )}
            
            {yingshiCameras.length > 0 ? (
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <Row gutter={[8, 8]}>
                  {yingshiCameras.map(camera => (
                    <Col span={12} key={`${camera.deviceSerial}-${camera.channelNo}`}>
                      <Card
                        size="small"
                        style={{
                          cursor: 'pointer',
                          backgroundColor: camera.selected ? '#f6ffed' : 'transparent',
                          border: camera.selected ? '1px solid #b7eb8f' : '1px solid #d9d9d9',
                        }}
                        onClick={() => handleToggleCamera(camera)}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: '13px' }}>
                          <Checkbox
                            checked={camera.selected}
                            style={{ marginRight: 8 }}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => handleToggleCamera(camera)}
                          />
                          <Avatar 
                            size="small"
                            icon={<VideoCameraOutlined />} 
                            style={{ 
                              backgroundColor: camera.status === 1 ? '#52c41a' : '#f5222d',
                              marginRight: 8
                            }}
                          />
                          <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <div style={{ fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {camera.channelName}
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              通道号: {camera.channelNo}
                              <Tag 
                                color={camera.status === 1 ? 'success' : 'error'} 
                                style={{ marginLeft: 4, fontSize: '10px', padding: '0 2px', lineHeight: '14px', height: '16px' }}
                              >
                                {camera.status === 1 ? '在线' : '离线'}
                              </Tag>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            ) : selectedCameras.length > 0 ? (
              <div style={{ maxHeight: '200px', overflowY: 'auto' }}>
                <Row gutter={[8, 8]}>
                  {selectedCameras.map(camera => (
                    <Col span={12} key={`${camera.deviceSerial}-${camera.channelNo}`}>
                      <Card
                        size="small"
                        style={{
                          backgroundColor: '#f6ffed',
                          border: '1px solid #b7eb8f',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: '13px' }}>
                          <Avatar 
                            size="small"
                            icon={<VideoCameraOutlined />} 
                            style={{ 
                              backgroundColor: camera.status === 1 ? '#52c41a' : '#f5222d',
                              marginRight: 8
                            }}
                          />
                          <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            <div style={{ fontWeight: 500, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {camera.channelName}
                              <CheckCircleFilled style={{ color: '#52c41a', marginLeft: 4, fontSize: '12px' }} />
                            </div>
                            <div style={{ fontSize: '12px', color: '#666' }}>
                              通道号: {camera.channelNo}
                              <Tag 
                                color={camera.status === 1 ? 'success' : 'error'} 
                                style={{ marginLeft: 4, fontSize: '10px', padding: '0 2px', lineHeight: '14px', height: '16px' }}
                              >
                                {camera.status === 1 ? '在线' : '离线'}
                              </Tag>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            ) : (
              <Empty description="未找到通道" image={Empty.PRESENTED_IMAGE_SIMPLE} />
            )}
          </div>
        ) : (
          <Empty description="请先选择设备" image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Spin>
    </div>
  );
};

export default YingshiCameraList; 